export default __webpack_public_path__ + "static/media/intro_preview.57ae52a6.png";